import { Injectable } from '@angular/core';

@Injectable()
export class PriceUrl {
    public static get GET_MODEL_PRICE(): string { return '/api/Price/Model'; }
    public static get GET_CURRENCIES(): string { return '/api/Price/currency'; }
    public static get GET_DEFAULT_CURRENCY(): string { return '/api/Price/DefaultCurrency'; }
    public static get GET_PRICE_LIST(): string { return '/api/Price'; }
    public static get GET_CENTRE_CONSULTATION_FEE(): string { return '/api/Price/consultationFees'; }
    public static get ADD_NEW_PRICE(): string { return '/api/Price'; }    
    public static get UPDATE_PRICE(): string { return '/api/Price/update/'; }    
    public static get DELETED_PRICE(): string { return '/api/Price/delete/'; }    
    public static get GET_PRICE_FOR_ADD(): string { return '/api/Price/getpricebymodel'; }    
    public static get ADD_NEW_PRICE_CONSULTATIONFEE(): string { return '/api/Price/consultationfee'; }    
    public static get UPDATE_PRICE_CONSULTATIONFEE(): string { return '/api/Price/update/{id}/consultationfee'; }    
    public static get DELETED_PRICE_CONSULTATIONFEE(): string { return '/api/Price/delete/{id}/consultationfee'; }    
    public static get GET_PRICE_FOR_ADD_CONSULTATIONFEE(): string { return '/api/Price/consultationfee/'; } 
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/price.url.ts